"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.InfoText = styled_components_1.default(react_native_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-self: flex-end;\n    font-size: 16px;\n    font-family: Roboto;\n    font-style: italic;\n    line-height: 20px;\n    color: ", ";\n"], ["\n    align-self: flex-end;\n    font-size: 16px;\n    font-family: Roboto;\n    font-style: italic;\n    line-height: 20px;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.dark;
});
exports.InfoTextFixer = styled_components_1.default(exports.InfoText)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-self: center;\n    padding-bottom: 32px;\n"], ["\n    align-self: center;\n    padding-bottom: 32px;\n"])));
var templateObject_1, templateObject_2;